import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import PhotoSwipe from '@PhotoSwipe'
import { destroyVideos, setupVideos } from '../../_video'

// eslint-disable-next-line import/prefer-default-export
export async function initializeProductDetail($container) {
  const container = $container[0]

  const photos = await Promise.all(
    $container.data('photos-and-videos')
      .filter((item) => !!(item.width))
      .map(async (item) => {
        item.url = window.APP.context.site.files_url + item.path
        return item
      }),
  );

  (() => {
    const mainCarouselView = container.querySelector('.product-detail__media-large .swiper')
    if (!mainCarouselView) {
      return
    }

    const mainCarousel = new Swiper(mainCarouselView, {})

    const mainPhotos = container.querySelectorAll('.js-media-photo')
    mainPhotos.forEach((photoNode, index) => {
      photoNode.addEventListener('click', () => {
        const gallery = new PhotoSwipe({
          index,
          bgOpacity: 1,
          dataSource: photos.map((item) => ({
            src: item.url,
            w: item.width,
            h: item.height,
          })),
        })
        gallery.init()
      }, false)
    })

    const thumbnails = container.querySelectorAll('.js-media-thumb')
    if (!thumbnails.length) {
      return
    }

    const onThumbClick = (index) => () => {
      mainCarousel.slideTo(index)
    }

    const followMainCarousel = () => {
      const previous = mainCarousel.previousIndex
      const selected = mainCarousel.realIndex
      if (previous !== undefined) {
        thumbnails[previous].classList.remove('is-selected')
      }
      thumbnails[selected].classList.add('is-selected')
    }

    thumbnails.forEach((thumbNode, index) => {
      const onClick = onThumbClick(index)
      thumbNode.addEventListener('click', onClick, false)
    })

    mainCarousel.on('realIndexChange', () => {
      const previous = mainCarousel.previousIndex
      const selected = mainCarousel.realIndex

      destroyVideos(mainCarousel.slides[previous])
      setupVideos(mainCarousel.slides[selected])
      followMainCarousel()
    })
    followMainCarousel()
  })()
}
